import React from "react";
import { jwtDecode } from "jwt-decode";
import setAuthToken from "./utils/setAuthToken";

// redux imports
import { setCurrentUser, logoutUser } from "./reducers/authSlice";
import { setColorMode } from "./reducers/themeSlice";
import { Provider } from "react-redux";
import store from "./store";

// localization provider
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'

// routes app component
import AppRoutes from "./AppRoutes";

// set color mode
if(localStorage.colorMode !== undefined) 
  store.dispatch(setColorMode(localStorage.colorMode));
else 
  store.dispatch(setColorMode('light'));

// JWT stuff
// Check for token to keep user logged in
if (localStorage.jwtToken) {
  const token = localStorage.jwtToken;
  setAuthToken(token); // Set auth token header auth

  const decoded = jwtDecode(token); // Decode token and get user info and exp
  store.dispatch(setCurrentUser(decoded)); // Set user and isAuthenticated

  // Check for expired token
  const currentTime = Date.now() / 1000; // to get in milliseconds
  if (decoded.exp < currentTime) {
    store.dispatch(logoutUser()); // Logout user
    window.location.href = "./login"; // Redirect to login
  }
}

function App() {

  return (
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale='es'>
        <AppRoutes />
      </LocalizationProvider>
    </Provider>
  );
}

export default App;
